import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import OptimisationSection from '../components/home/OptimisationSection';
import FilmsSection from '../components/home/FilmsSection';
import DepollutionSection from '../components/home/DepollutionSection';
import E85Section from '../components/home/E85Section';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black font-sans">
      <Helmet>
        <title>Ecotint & Reprog | Reprogrammation Moteur & Films Solaires à Eugénie les Bains (40)</title>
        <meta name="description" content="Expert en reprogrammation moteur (Stage 1, Stage 2, E85) et pose de films solaires à Eugénie les Bains dans les Landes. Voiture de prêt gratuite." />
        <link rel="canonical" href="https://ecotint-reprog.fr/" />
      </Helmet>
      <Header />
      <main>
        <HeroSection />
        <OptimisationSection />
        <FilmsSection />
        <DepollutionSection />
        <E85Section />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;